<template>
  <div class="title">
    <div class="titleContent clearfix">
      <div class="titleLogo fl clearfix">
        <router-link class="fl" to="/index"
          ><img
            style="width: 230px; height: 56px"
            src="../../assets/imgs/Group 10.png"
            alt="logo"
        /></router-link>
        <span v-if="flags" class="fl">个人中心</span>
        <span v-if="!flags" class="fl">单位中心</span>
      </div>
      <div class="fr titlePersonal clearfix">
        <div class="avatar fl">
          <img
            src="../../assets/imgs/personAvatar.png"
            alt="科研人才网-高校教师博士科研人才招聘"
          />
        </div>
        <div class="fl msg">
          <p>{{ telPhone }}</p>
          <p>
            <span v-if="flags">个人</span><span v-if="!flags">单位</span
            ><i>已登陆</i>
          </p>
          <div class="lofinOut">
            <p v-if="flags">
              <router-link target="_blank" to="/personalCenter"
                >个人中心</router-link
              >
            </p>
            <p v-if="!flags">
              <router-link target="_blank" to="/companyCerter"
                >单位中心</router-link
              >
            </p>
            <p @click="logOut">退出</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "header1",
  data() {
    return {
      telPhone: "",
      flags: true,
    };
  },
  created: function () {
    let telnumber = localStorage.getItem("_userName");
    let userCoookie = this.getCookie("session_token");
    if (userCoookie == null || userCoookie == "") {
      return false;
    }
    let myreg = /^1\d{10}$/;
    if (!myreg.test(parseInt(telnumber))) {
      this.flags = false;
    }
    this.telPhone = telnumber.slice(0, 3) + "****" + telnumber.slice(7);
  },
  methods: {
    logOut() {
      localStorage.setItem("_token", "");
      localStorage.setItem("_id", "");
      this.loginPersonFlag = false;
      this.loginCompanyFlag = false;
      localStorage.setItem("_userName", "");
      this.setCookie("session_token", "");
      this.$message({
        message: "退出成功！",
        type: "success",
      });
      this.$router.push({ path: "/login" });
    },
  },
};
</script>
<style scoped = "scoped"  lang = "less">
.title {
  background-color: white;
  height: 80px;
  line-height: 80px;
  /* overflow: hidden; */
  .titleContent {
    width: 1200px;
    margin: 0 auto;
    .titleLogo {
      height: 80px;
      line-height: 80px;
      /* overflow: hidden; */
      img {
        margin-top: 14px;
        margin-right: 20px;
      }
      span {
        display: inline-block;
        height: 40px;
        line-height: 40px;
        padding-left: 20px;
        margin-top: 20px;
        border-left: 1px solid #e5e5e5;
      }
    }
    .titlePersonal {
      height: 40px;
      margin-top: 14px;
      .avatar {
        img {
          width: 38px;
          height: 38px;
          border-radius: 50%;
        }
      }
      .msg {
        margin-top: 10px;
        margin-left: 10px;
        position: relative;
        height: 60px;
        p {
          height: 12px;
          line-height: 12px;
          font-size: 12px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: #333;
          span {
            color: #1787fb;
          }
          i {
            font-style: normal;
            margin-left: 6px;
          }
        }
        p:first-child {
          margin-bottom: 10px;
        }
        .lofinOut {
          display: none;
          position: absolute;
          top: 54px;
          left: 0;
          background-color: white;
          width: 100px;
          text-align: center;
          box-shadow: 4px 4px 2px #999;
          z-index: 999;
          height: 50px;
          p {
            cursor: pointer;
            line-height: 24px;
            color: #333;
          }
          a {
            display: block;
            margin: 0;
            color: #333;
          }
          p:hover {
            text-decoration: underline;
          }
        }
      }
      .msg:hover .lofinOut {
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/header1.vue